import { render, staticRenderFns } from "./weiji.vue?vue&type=template&id=67a50e43&scoped=true"
import script from "./weiji.vue?vue&type=script&lang=js"
export * from "./weiji.vue?vue&type=script&lang=js"
import style0 from "./weiji.vue?vue&type=style&index=0&id=67a50e43&prod&lang=css"
import style1 from "./weiji.vue?vue&type=style&index=1&id=67a50e43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a50e43",
  null
  
)

export default component.exports